<template>
  <Timeline
    :title="$t('nav.public_tl')"
    :timeline="timeline"
    :timeline-name="'public'"
  />
</template>

<script src="./public_timeline.js"></script>
